import React, {useEffect} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Chip, CircularProgress, Divider, Grid} from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import LastUpdate from "../../components/LastUpdate/LastUpdate";
import {connect} from "react-redux";
import {Typography} from "../../components/Wrappers/Wrappers";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from 'lodash'
import {dynamicStringSort, format_date, getMonth} from "../../utils";
import LinearWithValueLabel from "./components/LinearProgressWithLabel";

function Offers(props) {
    var classes = useStyles();

    useEffect(() => {
        document.title = 'Ihre Buchungen'
        window.scrollTo(0, 0)
    }, [])

    const accordionTitle = (offer) => {
        if (offer.quantity > 0) {
            return `#${offer.id}: ${offer.quantity}x ${offer.duration}-Tage Stellenanzeige(n) à ${_.round(offer.price_per_job_offer, 2).toFixed(2)}€ - ${offer.company}`
        } else {
            return `#${offer.id}: ∞ ${offer.duration}-Tage Stellenanzeige(n) à ${_.round(offer.price_per_job_offer, 2).toFixed(2)}€ - ${offer.company}`
        }
    }

    const clickJob = (id) => {
        return () => {
            props.history.push(`/app/job/${id}`)
        }
    }

    const valueProgress = (offer) => {
        if (offer.quantity > 0) {
            return ((offer.quantity - offer.remaining_value) / offer.quantity) * 100
        }
        return 0
    }

    const buildORVGroup = (offer) => {
        const groups = _.groupBy(offer.jobs, function (item) {
            return item.created_at.substring(0, 7);
        });
        const data = _(groups).toPairs().sortBy(0).fromPairs().value()
        // https://stackoverflow.com/a/46300019/2545832
        return _.map(_.toPairs(data), d => _.fromPairs([d]))
    }

    const createAccordionDetails = (offer) => {
        if (offer.quantity > 0) {
            return (<Grid item xs={12}>
                {offer.jobs.map(e => (
                    <Grid item xs={12} key={e.id} onClick={clickJob(e.id)}>
                        <Grid container justify="space-between" alignItems={'center'}
                              className={classes['rowOffer']}>
                            <Typography>{e.title} - {e.company} - {format_date(e.created_at)} -> {format_date(e.finished_at)}</Typography>
                            <Chip label={e.finished ? "Offline" : "Online"}
                                  className={e.finished ? classes['secondary'] : classes['success']}/>
                        </Grid>
                        <Divider/>
                    </Grid>))}
            </Grid>)
        } else {

            return (
                <Grid item xs={12}>
                    {buildORVGroup(offer).map((e, i) => {
                        const k = Object.keys(e)[0]
                        const v = e[k]
                        return (
                            <Accordion key={`oa${offer.id}${i}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <Grid container justify="space-between" alignItems={'center'}>
                                        <Typography
                                            className={classes.heading}>{`${getMonth(k)} - ${v.length} Stellenanzeigen`}</Typography>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                        {v.map(e => <Grid item xs={12} key={e.id} onClick={clickJob(e.id)}>
                                            <Grid container justify="space-between" alignItems={'center'}
                                                  className={classes['rowOffer']}>
                                                <Typography>{e.title} - {e.company} - {format_date(e.created_at)} -> {format_date(e.finished_at)}</Typography>
                                                <Chip label={e.finished ? "Offline" : "Online"}
                                                      className={e.finished ? classes['secondary'] : classes['success']}/>
                                            </Grid>
                                            <Divider/>
                                        </Grid>)}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        )
                    })}
                </Grid>
            )
        }
    }

    const createAccordion = (offer) => (
        <Accordion key={`o${offer.id}`}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
            ><Grid container justify="space-between" alignItems={'center'}>
                <Typography className={classes.heading}>{accordionTitle(offer)}</Typography>
                <LinearWithValueLabel value={valueProgress(offer)} remaining_value={offer.remaining_value} quantity={offer.quantity}/>
            </Grid>
            </AccordionSummary>
            <AccordionDetails>
                {createAccordionDetails(offer)}
            </AccordionDetails>
        </Accordion>
    )
    if (!Object.keys(props.profile).length) {
        return <CircularProgress color="secondary"/>
    }
    if (!props.profile.offers.length) {
        return <PageTitle title="Keine Buchungen"/>
    } else {
        return (

            <>
                <PageTitle title="Ihre Buchungen"/>
                <LastUpdate lastUpdateDate={props.profile.updated_at}/>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        {props.profile.offers.sort(dynamicStringSort("company")).map(createAccordion)}
                    </Grid>
                </Grid>
            </>
        );
    }
}

const mapStateToProps = (
    {
        profile,
    },
    ) => {
        return {
            profile,
        };
    }
;


export default connect(mapStateToProps)(Offers);
